import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import styles from './form-input.module.scss';

type FormInputProps = {
	inputLabel: string;
	value: string;
	validInput: boolean;
	placeholder?: string;
	inputType?: React.HTMLInputTypeAttribute;
	disabled?: boolean;
	maxWidth?: string;
	width?: string;
	autocomplete?: React.InputHTMLAttributes<HTMLInputElement>['autoComplete'];
	setValue: (newValue: string) => void;
};

export const FormInput: React.FC<FormInputProps> = ({
	inputLabel,
	placeholder,
	setValue,
	value,
	validInput,
	maxWidth,
	width,
	inputType,
	autocomplete,
	disabled = false,
}) => {
	return (
		<div
			className="cyber-input"
			style={{ maxWidth: maxWidth, width: width }}
		>
			<Label className="cyber-input__label">{inputLabel}</Label>
			<Input
				className={styles['form-input']}
				autoComplete={autocomplete}
				disabled={disabled}
				type={inputType}
				style={
					!validInput && value !== ''
						? { borderColor: 'red' }
						: { borderColor: '#dbdbdf' }
				}
				onChange={(event) => {
					setValue(event.target.value);
				}}
				placeholder={placeholder}
				value={value}
			/>
		</div>
	);
};
